<template>
     <div>
        
        <section id="MainpageSlider">
            <VueSlickCarousel  v-bind="settings" class="Modern-Slider"  v-if="sliderItems.length">
                  
                    <!-- Item -->
                    <div class="item"  v-for="sliderItem of sliderItems" v-bind:key="sliderItem._id">
                        
                        <div class="img-fill">
                            <img :src="'https://cdn.tavakademi.com/uploads/5ef1b5f29a24df0df44f084c/sliders/' + sliderItem.fileName" alt="" width="100%">
                            <div class="info">
                                <div>
                                    <div :inner-html.prop="sliderItem.subDescription"></div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <!-- // Item -->
                                       
            </VueSlickCarousel>
            <!--<div class="container">
                    <h1 class="yellow">TAV GÜVENLİK</h1>
                    <h1 class="bold">TAM GÜVENLİK</h1>
                    <h3>UÇAK ÖZEL GÜVENLİK HİZMET ve DENETİMİ</h3>
            </div>
            <div class="navigation-dots">
                    <a href="#"></a>
                    <a href="#"></a>
                    <a  href="#" class="selected"></a>
                    <a href="#"></a>
                    <a href="#"></a>
                    <a href="#"></a>
            </div>-->
        </section>
    </div>
</template>

<script>

import ContentService from '@/services/ContentService.js';
import VueSlickCarousel from 'vue-slick-carousel'
 // optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
            
export default {
    data() {
      return {
        sliderItems: [],
        settings: {
            autoplay:true,
            autoplaySpeed:10000,
            speed:600,
            slidesToShow:1,
            slidesToScroll:1,
            pauseOnHover:false,
            dots:true,
            pauseOnDotsHover:true,
            cssEase:'linear',
            // fade:true,
            draggable:false,
            arrows:false,
            infinite: true 
        },
      }
    },
    created () {
        ContentService.getMainSlider(this.$application, this.$t("languageCode"))
            .then(res => this.sliderItems = res.data.data)
            .catch(error => console.log('There was an error:' + error))   
    },
    // All slick methods can be used too, example here
    methods: {
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
        onInitCarousel() {
        console.log('our carousel is ready')
      }
    },
    components: {
        VueSlickCarousel
    }
  }
  
</script>

<style>
</style>